var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.screen === 'staff')?_c('staff'):_vm._e(),(_vm.screen === 'functional-interviews')?_c('functional-interview'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }